module.exports = __webpack_public_path__ + "static/img/F.39af4e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl2/F.png
// module id = 8eiY
// module chunks = 0